import { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { iupacToRegex } from "@/lib/science/iupac";
import { SciOutputBox } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";

export function IupacRegexCalc() {
  const [motif, setMotif] = useState("");
  const result = useMemo(
    () => (motif.trim() ? iupacToRegex(motif) : null),
    [motif],
  );

  return (
    <div className="sci-card rounded-2xl p-6 sm:p-8">
      <div className="space-y-1.5">
        <Label htmlFor="iupac-input" className="text-muted-foreground">
          {m.iupac_input_label()}
        </Label>
        <Input
          id="iupac-input"
          type="text"
          autoComplete="off"
          spellCheck={false}
          placeholder={m.iupac_input_placeholder()}
          value={motif}
          onChange={(e) => setMotif(e.target.value)}
          className="border-black/15 bg-white font-mono text-neutral-900 placeholder:text-neutral-500 hover:border-black/25 dark:border-black/15 dark:bg-white dark:text-neutral-900 dark:placeholder:text-neutral-500"
        />
      </div>

      {result == null ? (
        <p className="mt-5 text-sm text-muted-foreground">
          {m.iupac_hint_empty()}
        </p>
      ) : result.ok ? (
        <SciOutputBox
          label={m.iupac_output_label()}
          value={result.pattern}
          testId="iupac-output"
        />
      ) : (
        <p className="mt-5 text-sm text-red-500 dark:text-red-400" role="alert">
          {result.error}
        </p>
      )}
    </div>
  );
}
